export const baseUri = process.env.REACT_APP_PUBLIC_URL || '';
export const envTenant = process.env.REACT_APP_TENANT || 'sunrise';
export const IS_PRODUCTION =
  process.env.REACT_APP_PRODUCTION !== undefined ? process.env.REACT_APP_PRODUCTION === 'production' : true;
export const DEFAULT_PROD_LOGIN_PAGE = process.env.REACT_APP_LOGIN_PAGE || 'https://sbp.sunrise.ch/dashboard';
export const CONTACT_PAGE = process.env.REACT_APP_CONTACT_PAGE || 'https://www.sunrise.ch/de/support/kontakt';
